import { IRemoteRefreshSchedule } from '../types/IRemoteRefreshSchedule';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateRemoteRefreshScheduleParams {
  targetId: string;
  initial:  IRemoteRefreshSchedule;
  final:  IRemoteRefreshSchedule;
}

export class UpdateRemoteRefreshScheduleRequest extends Request<IUpdateRemoteRefreshScheduleParams, IResult> {
  constructor(params: IUpdateRemoteRefreshScheduleParams) {
    super('updateRemoteRefreshSchedule', params);
  }
}
